module.exports = __webpack_public_path__ + "static/img/defaultface.08a5227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultface.png
// module id = 96+U
// module chunks = 89